import { css } from 'styled-components';
import { BaseButtonProps } from 'types';
import { buttonBorderAndColorDecorator } from 'utils';
import { base } from './base';

export const outlined = ({ background, ...rest }: BaseButtonProps) => css`
	${base(rest)}
	line-height: 1.5rem;
	${buttonBorderAndColorDecorator(background)}
`;
